'use client';

import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import ProfileHeader from './components/ProfileHeader';
import PersonalInfo from './components/PersonalInfo';
import CredentialUploads from './components/CredentialUploads';
import AvailabilitySchedule from './components/AvailabilitySchedule';
import ContactDetails from './components/ContactDetails';

export type ProfileTab = 'personal' | 'credentials' | 'availability' | 'contact';

export default function MyProfilePage() {
  const [activeTab, setActiveTab] = useState<ProfileTab>('personal');

  return (
    <AppLayout>
      <div className="space-y-5 fade-in">
        <ProfileHeader activeTab={activeTab} onTabChange={setActiveTab} />
        {activeTab === 'personal' && <PersonalInfo />}
        {activeTab === 'credentials' && <CredentialUploads />}
        {activeTab === 'availability' && <AvailabilitySchedule />}
        {activeTab === 'contact' && <ContactDetails />}
      </div>
    </AppLayout>
  );
}
